
import Vue, { PropType } from 'vue'
import UserEntity, { IUserProps } from '@/entities/User'

const component = Vue.extend({
  props: {
    value: {
      type: Object as PropType<IUserProps>,
      default: null
    }
  },
  methods: {
    u(value?: IUserProps): UserEntity {
      return new UserEntity(value)
    }
  }
})

Vue.component('AAvatar', component)
export default component
